import React, { useState, useRef } from "react";
import agent1 from "../../assets/restaurantQRscan.svg";
import agent2 from "../../assets/conciergeQRscan.svg";
import agent3 from "../../assets/museumQRscan.svg";
import CardInfo from "../../assets/CardInfoIcon.svg";
import Playing from "../../assets/playing.gif";
import Pill from "../common/Pill";
import PlayButton from "../../assets/PlayBtn.svg";
import voice1 from "../../assets/RusselDaniel.mpeg";
import voice2 from "../../assets/MichealDoe.mpeg";
import voice3 from "../../assets/KurtHawkings.mpeg";

const VoiceAssistant = () => {
  const assistants = [
    {
      name: "Russel",
      tagline: "Ready for your restaurants",
      image: agent1,
      voice: voice3,
    },
    {
      name: "Michael",
      tagline: "24/7 always-on concierge",
      image: agent2,
      voice: voice1,
    },
    {
      name: "Kurt",
      tagline: "Well-versed guide for museums or exhibits",
      image: agent3,
      voice: voice2,
    },
  ];

  const [isPlaying, setIsPlaying] = useState(null);
  const audioRefs = useRef([]);

  const handlePlay = (index) => {
    const currentAudio = audioRefs.current[index];
    if (isPlaying === index) {
      currentAudio.pause();
      setIsPlaying(null);
    } else {
      audioRefs.current.forEach((audio, i) => {
        if (audio && i !== index) {
          audio.pause();
          audio.currentTime = 0;
        }
      });
      currentAudio.play();
      setIsPlaying(index);
    }
  };

  return (
      <section className="bg-gradient-to-b from-[#712424] via-[#000000] to-black text-white py-16 sm:py-20">
        <div className="max-w-6xl mx-auto px-4">
          {/* Heading */}
          <div className="text-center flex flex-col items-center gap-4 mb-10">
            <Pill text="Experience IT" backgroundColor="#FFFFFF1A" />
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold mb-2">
              Hear Our AI Voice Assistant
            </h2>
            <p className="text-gray-400 max-w-[600px] text-sm sm:text-base text-center leading-relaxed">
              Real, human-like conversations that enhance customer experience
              across any industry.
            </p>
          </div>
<div className="max-w-6xl mx-auto flex justify-between flex-wrap gap-4 sm:gap-6 md:gap-8">
  {assistants.map((assistant, index) => (
    <div
      key={index}
      className="flex-1 min-w-[280px] max-w-[360px] rounded-2xl overflow-hidden shadow-xl shadow-[#CDEEF440] bg-[#000000] p-[12px] border border-[#FFFFFF] text-white"
    >
      <div className="flex flex-col gap-3">
        <div>
          <img
            src={assistant.image}
            alt={assistant.name}
            className="w-full h-full object-cover"
          />
        </div>

        <div className="relative">
          <button
            onClick={() => handlePlay(index)}
            className="absolute top-0 left-1/2 -translate-x-1/2 flex items-center justify-center gap-2 bg-gradient-to-r from-[#8B000060] via-[#B22222] to-[#FF4D4D] font-semibold border border-[#FFFFFF4D] text-white text-xs sm:text-sm p-2 h-9 sm:h-10 rounded-full shadow-lg"
          >
            {isPlaying === index ? (
              <img src={Playing} alt="Playing" className="w-5 h-5" />
            ) : (
              <img
                src={PlayButton}
                alt="Play"
                className="w-[18px] sm:w-[20px] md:w-[24px] h-[18px] sm:h-[20px] md:h-[24px]"
              />
            )}
            {isPlaying === index ? "Pause Voice" : "Play Voice"}
          </button>

          <div className="w-full flex flex-row justify-center gap-4 items-center p-2 sm:p-3 md:p-4 mt-6 border border-[#ffffff5e] rounded-2xl bg-gradient-to-r from-[#000118] to-[#000000] text-center">
            <div>
              <img
                src={CardInfo}
                alt="Info icon"
                className="w-[60px]"
              />
            </div>
            <div className="flex flex-col text-left truncate">
              <h3 className="text-sm sm:text-base md:text-lg font-semibold truncate">
                {assistant.name}
              </h3>
              <p className="text-[10px] sm:text-xs md:text-sm text-gray-400 truncate">
                {assistant.tagline}
              </p>
            </div>
          </div>
        </div>
      </div>
      <audio
        ref={(el) => (audioRefs.current[index] = el)}
        src={assistant.voice}
        onEnded={() => setIsPlaying(null)}
      />
    </div>
  ))}
</div>

        </div>
      </section>
  );
};

export default VoiceAssistant;
